import { ImageSize } from '../../../types/index.mjs';

function getResizedImage(url, imageSize) {
  const imageSizeRegex = /_[a-z0-9]+(?=\.[a-z]{3,4}\?)/i;
  const newImageUrl = imageSize ? url.replace(imageSizeRegex, `_${imageSize}`) : url.replace(imageSizeRegex, '');
  return newImageUrl;
}
function getSizedImage(url, imageSize) {
  if (!imageSize) {
    return url;
  }
  const imageExtensionRegex = /\.[a-z0-9]{3,4}\?/i;
  const imageUrlExt = url.match(imageExtensionRegex) || '';
  return url.replace(imageExtensionRegex, `_${imageSize}${imageUrlExt[0]}`);
}
function getImageSizeFromUrl(url) {
  const imageSizeRegex = /_[a-z0-9]+(?=\.[a-z]{3,4}\?)/i;
  const matchArray = url.match(imageSizeRegex);
  let currentImageSize = ImageSize.Original;
  if (matchArray) {
    const size = matchArray[0].substr(1);
    currentImageSize = isValidImageSize(size) ? size : ImageSize.Original;
  }
  return currentImageSize;
}
function isValidImageSize(size) {
  return Object.values(ImageSize).includes(size);
}

export { getImageSizeFromUrl, getResizedImage, getSizedImage, isValidImageSize };
